<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="管理我的文件"
      width="640px"
      :showFooter="false"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-tree
        draggable
        class="sheet-tree"
        node-key="dataId"
        :data="sheetData"
        :props="defaultProps"
        :icon-class="`el-icon-folder`"
        :expand-on-click-node="clickType"
        :default-expanded-keys="expandedKeys"
        @node-click="handleNodeClick"
        @node-drag-enter="handleDragEnter"
        @node-drag-end="handleDragEnd"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
      >
        <span class="my-custom" slot-scope="{ node, data }">
          <template v-if="data.type === '1'">
            <svg class="icon svg-icon" aria-hidden="true" v-show="!node.expanded">
              <use xlink:href="#icon-folder"></use>
            </svg>
            <svg class="icon svg-icon" aria-hidden="true" v-show="node.expanded">
              <use xlink:href="#icon-opened_folder"></use>
            </svg>
          </template>
          <svg class="icon svg-icon" aria-hidden="true" v-else>
            <use xlink:href="#icon-file"></use>
          </svg>
          <span v-if="!data.editable">{{ data.folderName }}</span>
          <input v-model="data.folderName"  v-else/>
          <span class="node-operate">
            <!-- 收藏按钮 -->
            <!-- <span class="select" v-if="data.path">
              <span class="el-icon-star-off" @click.stop="onSelect(1, data)" v-if="data.favoriteFlag == '0'"></span>
              <span class="el-icon-star-on" @click.stop="onSelect(0, data)" v-if="data.favoriteFlag == '1'"></span>
            </span> -->
            <!-- 新增按钮 -->
            <span class="edit-icons" v-if="data.type === '1' && !data.editable">
              <span class="el-icon-edit" @click.stop="edit(data)"></span>
              <span  class="el-icon-delete" @click.stop="update(data, 2)"></span>
              <span class="el-icon-circle-plus-outline" @click.stop="append(data)"></span>
            </span>
            <!-- 节点可编辑状态 -->
            <span class="edit-icons" v-if="data.type === '1' && data.editable">
              <span class="el-icon-check" @click="addFolder(data)"></span>
              <span class="el-icon-close" @click="cancelCreate(data)"></span>
            </span>
          </span>
        </span>
      </el-tree>
    </q-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'modulesConfig'],
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'nodeName'
      },
      sheetData: [],
      operateStatus: '',  // ‘1’ 新增 ‘2’ 编辑
      expandedKeys: [],
      clickType: true,
      nodeName: '',
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      if (this.isNeedRefresh) {
        this.$emit('success');
      }
      this.$emit('close');
    },
    confirm() {
      this.updateVal();
    },
    init() {
      let data = {
        folderName: '',
        parentId: ''
      };
      return this.$q.shortVideoOverview.treeMenus({ data })
      .then(res=>{
        this.sheetData = res.data;
        // 默认展开根目录
        // this.expandedKeys.indexOf(this.sheetData[0].dataId) === -1 && this.expandedKeys.push(this.sheetData[0].dataId);
      })
    },
    handleNodeClick(data) {
      // console.log(data);
    },
    // 节点展开
    handleNodeExpand(data, node, $el) {
      this.expandedKeys.push(data.dataId);
    },
    // 节点折叠
    handleNodeCollapse(data, node, $el) {
      this.expandedKeys = this.expandedKeys.filter(v=>v!=data.dataId)
      if(data.children && data.children.length) {
        let childrenDataId = this.tree2flat(data.children).map(v=>v.dataId)
        this.expandedKeys = this.expandedKeys.filter(v=>!childrenDataId.includes(v))
      }
    },
    handleDragEnter(node, to, position) {
      // this.$message(`移动到${to.data.nodeName}${position}`)
    },
    handleDragEnd(node, to, position) {
      console.log(to.data);
      console.log(node);
      if(position === 'none') return;
      if(node.data.type === '2') {
        // 文件
        let parentNode;
        if(position === 'before' || position === 'after') {
          parentNode = this.tree2flat(this.sheetData).find(v=>v.dataId === to.data.parentId ? to.data.parentId : to.dataId);
        }else{
          parentNode = to.data;
        }
        console.log(parentNode);
        if(!parentNode || !parentNode.children) {
          this.$message.error('移动层级有误');
          this.init();
          return;
        }
        if(parentNode.path) {
          this.$message.error('不能移动到文件下');
          this.init();
          return;
        }
        node = {
          ...node.data,
          afterParentId: parentNode.dataId
        }
        console.log(node);
        this.moveFile(node,  parentNode.children.map(v=>v.dataId));
      }else{
        // 文件夹
        let isAllowInsert = this.isAllowInsert(node, to, position);
        if(isAllowInsert) {
          let parentNode;
          if(position === 'before' || position === 'after') {
            console.log(this.tree2flat(this.sheetData));
            parentNode = this.tree2flat(this.sheetData).find(v=>v.dataId === to.data.parentId);
          }else{
            parentNode = to.data;
          }
          console.log(parentNode);
          // 修改parnetId，传最新的parnetId
          node = {
            ...node.data,
            parentId: parentNode.dataId
          }
          console.log(node);
          this.update(node, 3, parentNode.children ? parentNode.children.map(v=>v.dataId) : [])
        }else{
          this.init();
        }
      }
    },
    // 判断当前拖拽的目标文件夹是否允许插入新文件夹&文件
    isAllowInsert(node, to, position) {
      console.log(to);
      console.log(node);
      if(position === 'before' || position === 'after') {
        // if(to.data.type === '1') {
        //   this.$message.error('只允许创建两层文件夹');
        //   return false;
        // }
        if(to.level == 1 && node.level == 1) {
          this.$message.error('不允许根目录文件移动');
          return false;
        }
        if(!to.data) {
          this.$message.error('不允许在根目录创建同级的文件夹');
          return false;
        }
        if(to.data.folderLevel !== node.data.folderLevel) {
          this.$message.error('只允许文件夹在同级目录下移动');
          return false;
        }
        return true;
      }else{
        if(to.data.type === '2') {
          this.$message.error('报表文件不能新增下级目录');
          return false;
        }
        if(to.data.folderLevel == 2) {
          this.$message.error('只允许创建两层文件夹');
          return false;
        }
        if(to.data.folderLevel !== node.data.folderLevel - 1) {
          this.$message.error('只允许文件夹在同级目录下移动');
          return false;
        }
        return true;
      }
    },
    append(data) {
      if( this.tree2flat(this.sheetData).find(v=>v.editable)) {
        this.$message.error('请先保存上一个目录，再新建文件夹。');
        return;
      }

      this.operateStatus = '1';

      const newChild = { nodeName: '新建文件夹', id: null, parentId: data.dataId, editable: true, children: null, type: '1' };
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(newChild);
      // 自动展开节点
      this.expandedKeys.indexOf(data.dataId) == -1 && this.expandedKeys.push(data.dataId);
    },
    cancelCreate(data) {
      if(this.operateStatus === '1') {
        let parentNode = this.tree2flat(this.sheetData).find(v=>v.dataId === data.parentId);
        console.log(parentNode);
        parentNode.children = parentNode.children.filter(v=>!v.editable);
      }else {
        data.folderName = this.nodeName
        data.editable = false
        setTimeout(() => {
        this.clickType = true
      }, 200);
      }
    },
    addFolder(data) {
      if(this.operateStatus == '1') {
        // 新增
        this.$q.shortVideoOverview.addFolder({data: {
          parentId: data.parentId,
          folderName: data.folderName,
        }})
        .then(res=>{
          if(res.code == 200) {
            this.$message.success('新增成功')
            this.$set(data, 'editable', false);
            this.init();
            this.$emit('complete', null)
          }else{
            this.$message.error(res.message)
            this.$set(data, 'nodeName', '新建文件夹');
          }
        })
      }else if(this.operateStatus == '2') {
        // 编辑
        this.update(data, 1);
      }
    },
    // 更新文件夹
   async update(data, type, folderIdList = []) {
      let requestData = {
        folderId: data.dataId,
        folderName: data.folderName,
        parentId: data.parentId,
        type: type,  //操作类型（1修改 2删除 3移动）
        folderIdList: folderIdList
      }
      if(type == 2) {
        let status = await this.$confirm("确认删除当前文件夹及其子文件夹吗？");
        if (status !== "confirm") return;
      }
      this.$q.shortVideoOverview.updateFolder({data: requestData})
      .then(res=>{
        if(res.code == 200) {
          if(type == 1) {
            this.$message.success('修改成功')
          }else if(type == 2) {
            this.$message.success('删除成功')
          }else if(type == 3) {
            this.$message.success('移动成功')
          }
          this.init();
          this.$emit('complete', null)
        }else{
          this.$message.error(res.message)
        }
      })
    },
    moveFile(data, reportDataIdList) {
      console.log(data);
      let requestData = {
        beforeFolderId: data.parentId,
        afterFolderId: data.afterParentId,
        fileDataIdList: reportDataIdList,
        dataId: data.dataId
      };
      this.$q.shortVideoOverview.moveFile({data: requestData})
      .then(res=>{
        if(res.code == 200) {
          this.$message.success('移动成功')
          this.init();
          this.$emit('complete', null)
        }else{
          this.$message.error(res.message)
        }
      })
      .catch(_=>{
        this.init();
      })
      console.log(999);
    },
    // 修改文件名
    edit(data) {
      this.clickType = false
      this.nodeName = data.folderName
      console.log(data.nodeName);
      this.operateStatus = '2';
      this.$set(data, 'editable', true);
    },
    // // 收藏、取消收藏
    // onSelect(status, data) {
    //   if(status) {
    //     // 收藏
    //   }else{
    //     // 取消收藏
    //     let requestData = {
    //       appCode: this.modulesConfig.appCode,
    //       subAppCode: this.modulesConfig.subAppCode,
    //       folderId: data.parentId,
    //       reportId: data.data.reportDataId,
    //       reportName: data.nodeName,
    //       type: '2'
    //     }
    //     this.$q.sheet.favorite({data: requestData})
    //     .then(res=>{
    //       if(res.code == 200) {
    //         this.$message.success('取消收藏')
    //       }else{
    //         this.$message.error(res.message)
    //       }
    //       this.init();
    //       this.$emit('complete', null)
    //     })
    //   }
    // },
    // tree数据转平级
    tree2flat(source) {
      let res = []
      const fn = (source)=>{
        source.forEach(el=>{
          res.push(el)
          el.children && el.children.length>0 ? fn(el.children) : ""
        });
      }
      fn(source)
      // const newArr = res.reduce(function (tempArr, item) { //去重
      //     if (tempArr.findIndex((ele) => ele.folderName === item.folderName) === -1) {
      //         tempArr.push(item)
      //     }
      //     return tempArr
      // }, [])
      return res;
    },
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-tree-node__expand-icon
    display block
    position relative
    left -100px
  >>> .el-tree-node__content
    width 100%
    box-sizing border-box

  .sheet-tree
    position reletive 

  .my-custom
    width 100%
    display inline-block
    padding-right 36px
    // user-select none
    position relative
  .node-operate
    position absolute
    right 15px
    top 1px
    width 120px

  
  .el-icon-star-on
    font-size 18.5px
    position absolute
    top 1px 
    right 0
    color rgb(255,160,0)
  .el-icon-star-off
    font-size 15px
    position absolute
    top 1px
    right 0
    color #999

  .edit-icons
    span
      display inline-block
      font-size 16px
      position absolute
      right: 120px
    .el-icon-circle-plus-outline
      color rgb(31,173,128)
      right 0
    .el-icon-edit
      color rgb(250,153,87)
      right 30px
    .el-icon-delete
      color rgb(227,122,112)
      right 60px
    .el-icon-check
      color rgb(31,173,128)
      right 90px
    .el-icon-close::before
      color rgb(227,122,112) !important

  .icon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    overflow: hidden;
    position relative
    top -1px
  }
</style>